import { usePublicLanguage } from './PublicLanguage';
import React from 'react';
import { BlogSummary, articleDate, articlePath } from './blog';
export default function ArticleCards({ posts }: { posts: BlogSummary[] }) {
  const { t, href, locale } = usePublicLanguage();
  return (
    <div className="blog-grid">
      {posts.map((post) => (
        <article className="blog-card" key={post.id}>
          {post.image && (
            <a
              href={
                post.contentLocale === 'en' ? articlePath(post.slug) : href(articlePath(post.slug))
              }
              tabIndex={-1}
              aria-hidden="true"
            >
              <img src={post.image} alt="" loading="lazy" />
            </a>
          )}
          <p className="home-small">
            <time dateTime={post.publishedAt}>{articleDate(post.publishedAt, locale)}</time>
          </p>
          <h3 lang={post.contentLocale}>
            <a
              href={
                post.contentLocale === 'en' ? articlePath(post.slug) : href(articlePath(post.slug))
              }
            >
              {post.title}
            </a>
          </h3>
          <p lang={post.contentLocale}>{post.excerpt}</p>
          {post.contentLocale === 'en' && locale !== 'en' && (
            <p className="home-small">{t('Available in English')}</p>
          )}
          <a
            className="home-text-link"
            href={
              post.contentLocale === 'en' ? articlePath(post.slug) : href(articlePath(post.slug))
            }
          >
            {t('Read article')}
            <span aria-hidden="true">↗</span>
          </a>
        </article>
      ))}
    </div>
  );
}
